import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation } from "@apollo/client";
import swal from "sweetalert";
import Header from "../../../../components/Header";
import { CREATE_LEADSOURCES, UPDATE_LEADSOURCES } from "../../../../data/SetupManagementData";

const LeadSourceForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const [createLeadSource] = useMutation(CREATE_LEADSOURCES, {
    onCompleted: () => {
      props.onClose();
      props.onAction();
      swal("Success!", "Lead Source has been created successfully", "success");
    },
    onError: () => {
      swal("Error!", "Unable to create Lead Source, try again later", "error");
    },
  });

  const [updateLeadSource] = useMutation(UPDATE_LEADSOURCES, {
    onCompleted: () => {
      props.onClose();
      props.onAction();
      swal("Success!", "Lead Source has been updated successfully", "success");
    },
    onError: () => {
      swal("Error!", "Unable to update Lead Source, try again later", "error");
    },
  });

  const initialValues = {
    leadSource: props.data ? props.data.leadSource : "",
   
  };

  const validationSchema = yup.object().shape({
    leadSource: yup.string().required("Lead Source is required"),
   
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (props.isEditing) {
        await updateLeadSource({
          variables: {
            id: props.data.id,
            ...values,
          },
        });
        console.log("Lead Source updated successfully!");
      } else {
        await createLeadSource({
          variables: {
            ...values,
          },
        });
        console.log("Lead Source created successfully!");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px" bgcolor="background.paper" p={3} borderRadius={8} boxShadow={3}>
      <Header
        title={props.isEditing ? "Edit Lead Source" : "Create Lead Source"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Lead Source"
            : "Create a New Lead Source"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Lead Source *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.leadSource}
                name="leadSource"
                error={touched.leadSource && !!errors.leadSource}
                helperText={touched.leadSource && errors.leadSource}
              />  
                       

              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default LeadSourceForm;
